module.exports = __webpack_public_path__ + "img/141ne.891a40a8.svg";